import React from 'react';

import SaveIcon from '@mui/icons-material/Save';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import DialogTitle from '@/components/DialogTitle';

/**
 * プロパティ
 */
export type Props = {
  /** 保存 */
  save: () => void,
  /**
   * 閉じる
   * @returns なし
   */
  cancel: () => void,
};

const ConfirmDraft: React.FC<Props> = ({
  save,
  cancel,
}) => (
  <Dialog
    open
    onClose={() => cancel()}
  >
    <DialogTitle title="下書き保存" />
    <DialogContent>
      <p>注意: 下書き保存では写真やファイルは保存されません。</p>
    </DialogContent>
    <DialogActions>
      <Button
        variant="contained"
        onClick={() => save()}
        color="primary"
        startIcon={<SaveIcon />}
      >
        続ける
      </Button>
      <Button variant="contained" onClick={() => cancel()} color="primary">
        キャンセル
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDraft;
